import { makeStyles } from "@fluentui/react-components";

export const useAllInteractionsStyle = makeStyles({
	container: {
		height: "100%",
		width: "100%",
		display: "flex",
		position: "relative",
		overflow: "unset",
	},
	leftTable: {
		width: "100%",
		paddingTop: "10px",
		containerName: "allWaitingInteractions",
		containerType: "inline-size",
	},
	rightTable: {
		width: "100%",
		height: "100%",
		paddingTop: "10px",
		overflowY: "auto",
	},
	resizeHintRight: {
		left: "-7px",
	},
	
	listHeaderMedia: {
		maxWidth: "90px",
		flexShrink: 0
	}
});
